import { supabase } from './supabase';
import { getLogger } from '../utils/logger';

const logger = getLogger('DIRECT-SIGNUP');

export interface DirectSignupBootstrapParams {
  userId: string;
  email: string;
  telefone?: string | null;
  metadata: Record<string, string>;
  clientPlatform: 'ios' | 'android' | 'web';
}

export interface DirectSignupBootstrapResponse {
  success: boolean;
  status: 'bootstrapped' | 'already_provisioned';
  empresa?: any;
  usuario?: any;
  subscription?: any;
  template?: any;
  stripeCustomerId?: string | null;
}

export const runDirectSignupBootstrap = async ({
  userId,
  email,
  telefone,
  metadata,
  clientPlatform,
}: DirectSignupBootstrapParams): Promise<DirectSignupBootstrapResponse> => {
  logger.info('[DIRECT-SIGNUP] Iniciando bootstrap direto', { userId });

  const { data, error } = await supabase.functions.invoke('bootstrap-direct-signup', {
    body: {
      user_id: userId,
      email,
      telefone: telefone ?? null,
      metadata,
      client_platform: clientPlatform,
    },
  });

  if (error) {
    logger.error('[DIRECT-SIGNUP] Falha ao executar bootstrap-direct-signup', error);
    throw new Error(error.message || 'Não foi possível provisionar sua conta automaticamente.');
  }

  try {
    await supabase.auth.refreshSession();
    logger.info('[DIRECT-SIGNUP] Sessão atualizada após bootstrap');
  } catch (refreshError) {
    logger.warn('[DIRECT-SIGNUP] Falha ao atualizar sessão após bootstrap', refreshError);
  }

  const response = (data || {}) as DirectSignupBootstrapResponse;
  logger.info('[DIRECT-SIGNUP] Bootstrap concluído', {
    userId,
    status: response.status,
  });

  return response;
};
